import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { GetAgendaUserQuery, GetAgendaUserQueryVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../graphql/API';
import { getAgendaUser } from './queries';
import { useLazyQuery, useQuery } from '@apollo/client';
import { useNavigate, useParams } from "react-router-dom";
import Image from 'react-bootstrap/Image';
import Stack from 'react-bootstrap/Stack';
import { useTranslation } from 'react-i18next';
import { Button, Container, Form, InputGroup, Modal, Spinner } from 'react-bootstrap';
import CustomModal from '../../components/Modals/CustomModal';
import { useFieldArray, useForm } from 'react-hook-form';
import { IoAddCircle, IoTrash } from 'react-icons/io5';
import axios from 'axios';

const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

type SignUpData = {
  // email: string;
  promoCode: string;
};

const CreateWorkersView = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [maxWorkers, setMaxWorkers] = useState(0);
  // NAVIGATION
  const navigate = useNavigate();
  // FORM
  const [workers, setWorkers] = useState([]);
  // const promoCode = ""; // Initialize promoCode with an empty string or a default value
  const {register, control, handleSubmit, watch, reset, formState: { errors }} = useForm<SignUpData>();
  // const { fields, append, remove } = useFieldArray({
  //   control,
  //   name: "emails",
  // });

  const {data: data, loading, error, refetch, fetchMore} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  const user = data?.getAgendaUser;

  useEffect(() => {
    document.title = t('title.billing');
  }, []);


  useEffect(() => {
    if (!user) return;
    if (!user.comId) return;
    if (!user.com) return;
    // if (user.com.account_type == "Starter") {
    //   setMaxWorkers(10);
    // }
  }, [user]);

  if (!user) {
    // if (loading || loadingUsers || loadingShift) {
    // if (loading || loadingUsers || loadingShift || !users || !shifts) { // need to keep it like that to load all before the loading stop
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const createFreePlan = async (promoCode: string) => {
    try {
      const response = await axios.post("/api/stripe/free_plan/", {
        userId: AuthUserId,
        comId: user.comId,
        promoCode
      });
  
      // console.log("create free plan:", response.data);
      return response.data; // Retourne le client token
    } catch (error) {
      console.error("Error when getting worker comId :", error);
      return null;
    }
  };


  const onRegisterPressed = async (data: SignUpData) => {
    // console.log('data',data);
      if (loadingForm) {
        return;
      };
      setLoadingForm(true);
      // if (user.comId && user.com.account_type == "") {
      //   setContentModal(<>
      //     <Modal.Header closeButton>
      //       <Modal.Title>{t('stripe.free.freeError')}</Modal.Title>
      //     </Modal.Header>
    
      //     <Modal.Body>
      //       <p>{t(`stripe.free.alreadyComId`)}</p>
      //     </Modal.Body></>);
      //   // setLinkModal(t('link.add_worker'));
      //   setShowCustomModal(true);
      //   setLoadingForm(false);
      //   return;
      // }
      try {

        // console.log("Emails à inscrire :", emails);
        
        if (data?.promoCode === "") {
          // alert("Veuillez entrer au moins un email !");
          setContentModal(<>
            <Modal.Header closeButton>
              <Modal.Title>{t('stripe.free.create')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('stripe.free.atleast_one_character')}</p>
            </Modal.Body></>);
          // setLinkModal(t('link.add_worker'));
          setShowCustomModal(true);
          setLoadingForm(false);
          return;
        }
        // console.log("Emails à inscrire :", emails);
        // console.log("max", workers.length + emails.length);
          const response = await createFreePlan(data.promoCode);
          if (response) {
            // console.log("RESPONSE", response.status);
            if (response.status == "success") {
              navigate(t('link.dashboard'))
            } else {
              setContentModal(<>
                <Modal.Header closeButton>
                  <Modal.Title>{t('stripe.free.freeError')}</Modal.Title>
                </Modal.Header>
          
                <Modal.Body>
                  <p>{response.message}.</p>
                </Modal.Body></>);
              setShowCustomModal(true);
            }
            // const parsedJson = JSON.parse(response);
            // console.log("RESPONSE", parsedJson);
            // console.log("RESPONSE", parsedJson.status);
          }
      } catch (error) {
        // console.log('Registration Error : ', error);
        setContentModal(<>
          <Modal.Header closeButton>
            <Modal.Title>{t('stripe.free.freeError')}</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            <p>{(error as Error).message}.</p>
          </Modal.Body></>);
        setShowCustomModal(true);
        // alert("Registering error: " + (error as Error).message);
      } finally {
        setLoadingForm(false);
        reset();
      };
    };
  
  return (
    <div className="users-container">
      <>
      <CustomModal
        show={showCustomModal}
        onHide={() => {
          setShowCustomModal(false);
          // window.location.reload();
        }}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      <Form className="register-form">
        <h2 className="text-center">{t('stripe.free.title')}</h2>
        <Container className="">
            
              <div style={{ marginBottom: "15px" }}>
              <InputGroup style={{ marginBottom: "5px" }}>
                <Form.Control
                  placeholder={t('stripe.free.promoCode')}
                  aria-label="{t('stripe.free.promoCode')}"
                  aria-describedby="basic-addon1"
                  className="d-inline me-lg-2"
                  {...register("promoCode")}
                  // name="email"
                />
                
              </InputGroup>
              {/* {errors.promoCode?.[index]?.email && (
                <span style={{ color: "maroon" }}>{errors.emails[index].email.message}</span>
              )} */}
              </div>
                
              {/* {(fields.length < (maxWorkers - workers.length) || fields.length < 20) && ( */}
              {/* {(fields.length < 10) && (
                <InputGroup>
                  <IoAddCircle size={40} className="add_icon" onClick={() => append({ email: "" })}/>
                </InputGroup>
              )} */}
            
              <InputGroup>
                <Button type="submit" onClick={handleSubmit(onRegisterPressed)} disabled={loadingForm}>{loadingForm ? <Spinner animation="border" size="sm" /> : t("profile.submit")}</Button>
              </InputGroup>

          </Container>
          {/* <Container style={{alignContent: 'center', textAlign: 'center'}}>
            { workers.length > 0 &&
              <>
              <Container>
                <h5>{t('worker.workers_list_title')}</h5>
              </Container>
              {workers.map((email, index) => (
                <Container key={index}>
                  <p>{email} <IoTrash size={40} className="delete_icon" onClick={() => removeWorker(user.comId, email)} /></p>
                </Container>
              ))}
              </>
            }
          </Container> */}
        </Form>
        </>
    </div>
  );
};

export default CreateWorkersView;


